import { PageId } from 'constants/pages'

export const enum PageIdWoofzPppBl {
  DOG_AGE_WOOFZ_PPP_BL = PageId.DOG_AGE_WOOFZ_PPP_BL,
  DOG_OWNER_WOOFZ_PPP_BL = PageId.DOG_OWNER_WOOFZ_PPP_BL,
  TRAINING_COMMANDS_WOOFZ_PPP_BL = PageId.TRAINING_COMMANDS_WOOFZ_PPP_BL,
  URGE_WOOFZ_PPP_BL = PageId.URGE_WOOFZ_PPP_BL,
  DOG_BREED_WOOFZ_PPP_BL = PageId.DOG_BREED_WOOFZ_PPP_BL,
  FACING_CHALLENGES_WOOFZ_PPP_BL = PageId.FACING_CHALLENGES_WOOFZ_PPP_BL,
  FACING_CHALLENGES_2_WOOFZ_PPP_BL = PageId.FACING_CHALLENGES_2_WOOFZ_PPP_BL,
  BEHAVIOR_FREQUENCY_WOOFZ_PPP_BL = PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_BL,
  URGE_PROGRAM_WOOFZ_PPP_BL = PageId.URGE_PROGRAM_WOOFZ_PPP_BL,
  BEHAVIOR_FEELINGS_WOOFZ_PPP_BL = PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_BL,
  FIX_BEHAVIOR_WOOFZ_PPP_BL = PageId.FIX_BEHAVIOR_WOOFZ_PPP_BL,
  URGE_4_WOOFZ_PPP_BL = PageId.URGE_4_WOOFZ_PPP_BL,
  COMMANDS_WOOFZ_PPP_BL = PageId.COMMANDS_WOOFZ_PPP_BL,
  PARENT_GOAL_WOOFZ_PPP_BL = PageId.PARENT_GOAL_WOOFZ_PPP_BL,
  TRAINING_PLACE_WOOFZ_PPP_BL = PageId.TRAINING_PLACE_WOOFZ_PPP_BL,
  TRAINING_FREQUENCY_WOOFZ_PPP_BL = PageId.TRAINING_FREQUENCY_WOOFZ_PPP_BL,
  URGE_5_WOOFZ_PPP_BL = PageId.URGE_5_WOOFZ_PPP_BL,
  PREPARE_FLOW_WOOFZ_PPP_BL = PageId.PREPARE_FLOW_WOOFZ_PPP_BL,
  COMMITMENT_SCREEN_PPP_BL = PageId.COMMITMENT_SCREEN_PPP_BL,
  EMAIL_WOOFZ_PPP_BL = PageId.EMAIL_WOOFZ_PPP_BL,
  NEWSLETTER_URGE_WOOFZ_PPP_BL = PageId.NEWSLETTER_URGE_WOOFZ_PPP_BL,
  LAST_CHANCE_OFFER_WOOFZ_PPP_BL = PageId.LAST_CHANCE_OFFER_WOOFZ_PPP_BL,
  SUBSCRIPTIONS_WOOFZ_PPP_BL = PageId.SUBSCRIPTIONS_WOOFZ_PPP_BL,
  CHAT_UPSELL_WOOFZ_PPP_BL = PageId.CHAT_UPSELL_WOOFZ_PPP_BL,
  UPSELL_WOOFZ_PPP_BL = PageId.UPSELL_WOOFZ_PPP_BL,
  UPSELL_FEEDING_GUIDE_WOOFZ_PPP_BL = PageId.UPSELL_FEEDING_GUIDE_WOOFZ_PPP_BL,
  UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP_BL = PageId.UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP_BL,
  DOWNLOAD_WOOFZ_PPP_BL = PageId.DOWNLOAD_WOOFZ_PPP_BL,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
